import React from 'react';
import { useTranslation } from 'react-i18next';
import ProfileImage from '../../profileImage';

const ParentsList = ({
  parents,
  onRemove,
  isRemoving
}) => {
  const { t } = useTranslation();

  if (parents.length === 0) {
    return (
      <div className="text-center py-12 bg-gray-50 rounded-lg">
        <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        </div>
        <h4 className="text-lg font-medium text-gray-900 mb-2">{t('player.parents.noParentsAdded')}</h4>
        <p className="text-gray-600">{t('player.parents.noParentsAddedDescription')}</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {parents.map((parent) => (
        <div key={parent._id || parent.id} className="bg-white border border-gray-200 rounded-lg p-4">
          <div className="flex items-center gap-4 mb-4">
            <ProfileImage
              image={parent.user?.profilePicture || parent.profilePicture}
              alt={parent.user?.userName || parent.userName}
              className="w-16 h-16 rounded-full object-cover"
            />
            <div>
              <h4 className="font-medium text-gray-900">
                {parent.user?.userName || parent.userName}
              </h4>
              <p className="text-sm text-gray-600">
                {parent.user?.firstName || parent.firstName} {parent.user?.lastName || parent.lastName}
              </p>
              <p className="text-xs text-gray-500">
                {t('player.parents.access')}: {Array.isArray(parent.role) ? parent.role.join(', ') : parent.role}
              </p>
              <p className="text-xs text-gray-400">
                {t('player.parents.added')}: {new Date(parent.createdAt).toLocaleDateString()}
              </p>
            </div>
          </div>
          <div className="flex justify-end">
            <button
              onClick={() => onRemove(parent.user?._id || parent._id || parent.id)}
              disabled={isRemoving}
              className="px-3 py-1 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 disabled:bg-gray-300 transition-colors text-sm"
            >
              {isRemoving ? t('player.parents.removing') : t('player.parents.remove')}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ParentsList; 